import React from 'react';
import { Linkedin, Mail, ArrowRight } from 'lucide-react';

function ApplyPopup({ onContinueWithEmail }) {
  return (
    <div className="md:pb-24 flex items-center justify-center p-4">
      <div className="bg-card rounded-2xl shadow-xl w-full max-w-md p-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-foreground mb-2">Apply following the steps below</h1>
          <p className="text-muted-foreground">Select your preferred application method</p>
        </div>

        <div className="space-y-4">
     

          <button
            className="w-full flex items-center justify-center gap-3 bg-muted text-foreground py-3 px-4 rounded-lg border border-border hover:bg-muted transition-colors"
            onClick={onContinueWithEmail}
          >
            <Mail className="w-5 h-5" />
            <span>Continue with Email</span>
            <ArrowRight className="w-4 h-4 ml-2" />
          </button>
        </div>

        <p className="mt-8 text-center text-sm text-muted-foreground hidden">
          By continuing, you agree to our{' '}
          <a href="#" className="text-blue-600 hover:underline">Terms of Service</a>
          {' '}and{' '}
          <a href="#" className="text-blue-600 hover:underline">Privacy Policy</a>
        </p>
      </div>
    </div>
  );
}

export default ApplyPopup;
